const getters = {
    GET_VOUCHER: (state) => state.voucher,
}

export default getters
